import OrderHistory from './OrderHistory';

export default OrderHistory;
